///////////////////////PERMISSION///////////////////////////////////
export const QUAN_LY_ADMIN = "quan-ly-admin";
export const QUAN_LY_MASTER = "quan-ly-master";
export const QUAN_LY_DS_MASTER = "quan-ly-danh-sach-master";
export const QUAN_LY_TAI_KHOAN = "quan-ly-tai-khoan";
export const QUAN_LY_CHO_VAY = "quan-ly-vay";
export const QUAN_LY_VAI_TRO = "quan-ly-vai-tro";
export const QUAN_LY_QUYEN = "quan-ly-quyen";
export const QUAN_LY_NHOM_QUYEN = "quan-ly-nhom-quyen";
export const THEM_MOI_ADMIN_CSKH = "them-moi-admin-cskh";
export const THEM_MOI_ADMIN = "them-moi-admin";
export const SUA_REF_NGUOI_DUNG = "edit-ref-user";

export const TRANG_CA_NHAN_ADMIN = "trang-ca-nhan-admin";
export const DOI_MAT_KHAU = "doi-mat-khau";

export const QUAN_LY_NGUOI_DUNG = "quan-ly-nguoi-dung";
export const THUONG_NGUOI_DUNG = "thuong-nguoi-dung";
export const QUAN_LY_TIEN_VANG_KHOA = "quan-ly-tien-vang-khoa";
export const QUAN_LY_TIEN = "quan-ly-tien";
export const QUAN_LY_VANG = "quan-ly-vang";
export const QUAN_LY_CHI_TIET_NGUOI_DUNG = "quan-ly-chi-tiet-nguoi-dung";

export const QUAN_LY_KYC = "quan-ly-kyc";
export const QUAN_LY_SAN_PHAM = "quan-ly-san-pham";
export const QUAN_LY_NOI_DUNG = "quan-ly-noi-dung";
export const QUAN_LY_TIN_TUC = "quan-ly-tin-tuc";
export const QUAN_LY_GIA_VANG = "quan-ly-gia-vang";
export const QUAN_LY_CHI_NHANH = "quan-ly-chi-nhanh";
export const QUAN_LY_GIAO_DICH = "quan-ly-giao-dich";
export const QUAN_LY_DS_GIAO_DICH = "danh-sach-giao-dich";
export const QUAN_LY_DON_HANG = "quan-ly-don-hang";
export const QUAN_LY_CAU_HINH = "quan-ly-cau-hinh";
export const NAP_TIEN_ADMIN = "nap-tien-admin";
export const QUAN_LY_POPUP = "quan-ly-popup";
export const QUAN_LY_BANNER = "quan-ly-banner";
export const QUAN_LY_MERCHANT = "quan-ly-merchant";
export const SETTING_POPUP = "settingPopupCMS";

export const QUAN_LY_REFERRAL = "quan-ly-referral";
export const QUAN_LY_CHI_TIET_REFERRAL = "quan-ly-chi-tiet-referral";
export const QUAN_LY_AGENCY = "quan-ly-agency";
export const QUAN_LY_PAGE = "quan-ly-page";

export const QUAN_LY_DAU_TU = "quan-ly-dau-tu";
export const QUAN_TRI_DAU_TU = "quan-tri-dau-tu";
export const QUAN_LY_NOTIFY = "quan-ly-notify";
export const SYSTEM_MANAGEMENT = "quan-tri-he-thong";
export const THUONG_KYC_DAI_LY = "thuong-kyc-dai-ly";
export const QUAN_LY_NGAN_HANG = "quan-ly-ngan-hang";
export const QUAN_LY_THONG_KE = "quan-ly-thong-ke";

export const QUAN_LY_DONG_TIEN = "quan-ly-dong-tien";
export const QUAN_LY_YC_VIP = "quan-ly-yeu-cau-nang-cap-vip";
export const QUAN_LY_NFC = "quan-ly-dong-vang-nfc";

export const LICH_SU_VOICEBOT = "lich-su-voicebot";
export const QUAN_LY_LI_XI = "quan-ly-li-xi";
export const XEM_DANH_SACH_NGUOI_DUNG = "xem-danh-sach-nguoi-dung";
export const DANH_SACH_YEU_CAU_KYC = "danh-sach-yeu-cau-kyc";
export const DANH_SACH_NGUOI_DA_GIOI_THIEU = "danh-sach-nguoi-da-gioi-thieu";
export const DANH_SACH_YEU_CAU_NANG_CAP = "danh-sach-yeu-cau-nang-cap";
export const XEM_NAP_TIEN = "xem-nap-tien";
export const XEM_MUA_VANG = "xem-mua-vang";
export const GIAO_DICH_MUA_HNG = "giao-dich-mua-hng";
export const GIAO_DICH_MUA_USD = "giao-dich-mua-usd";
export const GIAO_DICH_MUA_XAU = "giao-dich-mua-xau";
export const GIAO_DICH_BAN_XAU = "giao-dich-ban-xau";
export const GIAO_DICH_CUNG_HOP_TAC = "giao-dich-cung-hop-tac";
export const XEM_DANH_SACH_DAI_SU = "xem-danh-sach-dai-su";
export const DANH_SACH_DON_HANG = "danh-sach-don-hang";
export const QUAN_TRI_NGUOI_DUNG = "quan-tri-nguoi-dung";
export const QUAN_TRI_YEU_CAU_KYC = "quan-tri-yeu-cau-kyc";
export const QUAN_TRI_YEU_CAU_NANG_CAP_VIP = "quan-tri-yeu-cau-nang-cap-vip";
export const XEM_TAI_SAN_KHOA = "xem-tai-san-khoa";
export const XEM_KHOA_RUT_TIEN = "xem-khoa-rut-tien";
export const DANH_SACH_LOI_LO_NGUOI_DUNG = "danh-sach-loi-lo-nguoi-dung";
export const DANH_SACH_MOC_GIOI_THIEU = "danh-sach-moc-gioi-thieu";
export const QUAN_LY_THUONG_THEO_MOC_GIOI_THIEU =
  "quan-ly-thuong-theo-moc-gioi-thieu";
export const HOA_HONG_NGUOI_DUNG = "hoa-hong-nguoi-dung";
export const QUAN_LY_TRANG_CHU = "quan-ly-trang-chu";
export const QUAN_LY_HOMEPAGE = "quan-ly-homepage";
export const QUAN_LY_TRANG_DOI_TAC = "quan-ly-trang-doi-tac";
export const QUAN_LY_CAU_HINH_MARKETING = "quan-ly-cau-hinh-marketing";
export const QUAN_LY_DOI_SOAT_GIAO_DICH = "quan-ly-doi-soat-giao-dich";
export const QUAN_LY_DOANH_NGHIEP = "quan-ly-doanh-nghiep";
export const QUAN_LY_CHUONG_TRINH_LIXI = "quan-ly-chuong-trinh-li-xi";
export const QUAN_LY_EVOUCHER_DOANH_NGHIEP = "quan-ly-evoucher-doanh-nghiep";

export const QUAN_LY_PRIORITY = "quan-ly-priority";

///////////////////////END PERMISSION///////////////////////////////////

/////////////////////// Master ////////////////////////////////////////
export const renderType = (status, coin_id = 1) => {
  const type = [
    "cancel_withdraw_money",
    "deposit_money_admin_remove",
    "request_agency",
    "request_agency_root_add",
    "send_gold_agency_user",
    "swap_gold_money_root",
    "swap_gold_money_money_admin_remove",
    "swap_money_gold",
    "withdraw_gold_admin_cancel",
    "withdraw_gold_agency_cancel",
    "withdraw_gold_gold_admin_add",
    "swap_gold_money_root",
    "withdraw_gold_money_admin_add",
    "withdraw_gold_money_admin_remove",
    "withdraw_money_money_admin_add",
    "admin",
    "withdraw_gold_user_cancel",
    "admin_send_gold_admin_remove",
    "admin_send_money_admin_remove",
    "admin_deduct_gold_admin_add",
    "admin_deduct_money_admin_add",
    "by_order",
    "by_order_cancel",
    "referral_gold_inviter_remove_coin",
    "kyc_success_remove_coin",
    "use_voucher_gold_remove",
    "create_voucher_gold",
    "admin_send_gold",
    "commission_swap_money_gold",
    "LOAN_ADMIN_MONEY_REMOVE",
    "LOAN_ADMIN_GOLD_ADD",
    "CLOSE_LOAN_ADD_MONEY",
    "CLOSE_LOAN_REMOVE_GOLD",
    "PAY_LOAN_ADD_MONEY",
    "PAY_LOAN",
    "admin_lock_gold",
  ];
  const action = [
    "rút tiền - chuyển tiền - hủy rút tiền",
    "nạp tiền - chuyển tiền",
    "yêu cầu làm đại sứ",
    "yêu cầu làm đại sứ - nhận vàng",
    "gửi vàng từ đại sứ",
    "bán vàng - nhận vàng",
    "bán vàng - chuyển tiền",
    "mua vàng - " + (coin_id === 1 ? "cộng tiền" : "trừ vàng"),
    "rút vàng - admin hủy",
    "rút vàng - đại sứ hủy",
    "rút vàng - nhận vàng",
    "rút vàng - chuyển vàng",
    "rút vàng - nhận tiền",
    "rút vàng - chuyển tiền",
    "rút tiền - cộng tiền",
    "nạp tiền vào tài khoản Master",
    "rút vàng - " +
      (coin_id === 1 ? "trừ tiền" : "cộng vàng") +
      " - người dùng hủy",
    "chuyển vàng cho đại sứ",
    "chuyển tiền cho đại sứ",
    "thu hồi vàng cho đại sứ",
    "thu hồi tiền cho đại sứ",
    "nhận tiền mua hàng",
    "trả lại tiền mua hàng do hủy đơn",
    "master trả thưởng cho user khi được mời",
    "master trả thưởng cho user khi kyc thành công",
    "chuyển vàng từ master cho user",
    "nhận vàng từ đại sứ",
    "Admin gửi vàng",
    "Hoa hồng cho đại sứ khi user mua vàng",
    "Admin ứng tiền cho user vay",
    "Admin giữ vàng user vay",
    "Tất toán khoản vay admin nhận tiền",
    "Tất toán khoản vay admin trả vàng",
    "Nhận tiền thanh toán một phần từ khoản vay của user",
    "Thanh toán khoản vay",
    "Admin khóa vàng",
  ];
  const index = type.indexOf(status);
  if (index !== -1) {
    return action[index];
  } else return status;
};

export const transactionType = [
  "cancel_withdraw_money",
  "deposit_money_admin_remove",
  "request_agency",
  "request_agency_root_add",
  "send_gold_agency_user",
  "swap_gold_money_root",
  "swap_gold_money_money_admin_remove",
  "swap_money_gold",
  "withdraw_gold_admin_cancel",
  "withdraw_gold_agency_cancel",
  "withdraw_gold_gold_admin_add",
  "swap_gold_money_root",
  "withdraw_gold_money_admin_add",
  "withdraw_gold_money_admin_remove",
  "withdraw_money_money_admin_add",
  "admin",
  "withdraw_gold_user_cancel",
  "admin_send_gold_admin_remove",
  "admin_send_money_admin_remove",
  "admin_deduct_gold_admin_add",
  "admin_deduct_money_admin_add",
  "by_order",
  "by_order_cancel",
  "referral_gold_inviter_remove_coin",
  "kyc_success_remove_coin",
  "use_voucher_gold_remove",
  "create_voucher_gold",
  "admin_send_gold",
  "commission_swap_money_gold",
  "LOAN_ADMIN_MONEY_REMOVE",
  "LOAN_ADMIN_GOLD_ADD",
  "CLOSE_LOAN_ADD_MONEY",
  "CLOSE_LOAN_REMOVE_GOLD",
  "PAY_LOAN_ADD_MONEY",
  "PAY_LOAN",
  "admin_lock_gold",
];

export const transactionTypeLabel = [
  "rút tiền - chuyển tiền - hủy rút tiền",
  "nạp tiền - chuyển tiền",
  "yêu cầu làm đại sứ",
  "yêu cầu làm đại sứ - nhận vàng",
  "gửi vàng từ đại sứ",
  "bán vàng - nhận vàng",
  "bán vàng - chuyển tiền",
  "Mua vàng",
  "rút vàng - admin hủy",
  "rút vàng - đại sứ hủy",
  "rút vàng - nhận vàng",
  "rút vàng - chuyển vàng",
  "rút vàng - nhận tiền",
  "rút vàng - chuyển tiền",
  "rút tiền - cộng tiền",
  "Nạp tiền vào tài khoản Master",
  "Rút vàng - người dùng hủy",
  "Chuyển vàng cho đại sứ",
  "Chuyển tiền cho đại sứ",
  "Thu hồi vàng cho đại sứ",
  "Thu hồi tiền cho đại sứ",
  "Nhận tiền mua hàng",
  "Trả lại tiền mua hàng do hủy đơn",
  "Master trả thưởng cho user khi được mời",
  "Master trả thưởng cho user khi kyc thành công",
  "Chuyển vàng từ master cho user",
  "Nhận vàng từ đại sứ",
  "Admin gửi vàng",
  "Hoa hồng cho đại sứ khi user mua vàng",
  "Admin ứng tiền cho user vay",
  "Admin giữ vàng user vay",
  "Tất toán khoản vay admin nhận tiền",
  "Tất toán khoản vay admin trả vàng",
  "Nhận tiền thanh toán một phần từ khoản vay của user",
  "Thanh toán khoản vay",
  "Admin khóa vàng",
];
export const transactionType2 = {
  COMMISSION: {
    commission_swap_money_gold: "Hoa hồng cho đại sứ khi user mua vàng",
    cms_commission_vnđ: "Tạo thưởng tiền cms",
    cms_commission_chỉ: "Tạo thưởng vàng cms",
    cms_commission_hng: "Tạo thưởng hng cms",
    recover_assets_remove: "Hệ thống thu hồi",
    admin_send_gold: "Admin gửi vàng",
    admin_send_VND: "Admin gửi tiền",
    admin_send_HNG: "Admin gửi HNG",
    referral_gold_inviter_remove_coin: "Mời người dùng",
    ref_invest: "Hoa hồng đầu tư",
    send_agency_ref_gold: "Hoa hồng mua vàng lần đầu",
    send_agency_ref_kyc: "Thưởng KYC",
    ref_vip: "Hoa hồng nâng cấp vip",
    reward_claim_referal: "Hoa hồng claim",
  },
  INTEREST: {
    admin_send_gold: "Admin gửi vàng",
    admin_send_VND: "Admin gửi tiền",
    admin_send_HNG: "Admin gửi HNG",
    withdraw_invest_profit: "Rút lãi đầu tư",
    withdraw_invest_profit_root: "Rút vốn đầu tư",
    invest_root_add: "Người dùng đầu tư",
    reward_daily: "Thưởng hàng ngày",
    cms_commission_vnđ: "Tạo thưởng tiền cms",
    cms_commission_chỉ: "Tạo thưởng vàng cms",
    cms_commission_hng: "Tạo thưởng hng cms",
    recover_assets_remove: "Hệ thống thu hồi",
  },
  MARKETING: {
    admin_send_VND: "Admin gửi tiền",
    admin_send_gold: "Admin gửi vàng",
    admin_send_HNG: "Admin gửi HNG",
    reward_user_buy_HNG_admin_remove: "Thưởng mua HNG",
    send_reward_new_account: "Thưởng tài khoản mới(CHỈ)",
    kyc_success_remove_coin: "Thưởng KYC đăng ký",
    lixi_remove_coin: "Lì xì",
    ref_register: "Thưởng tạo tài khoản mới(VNDC)",
    reward_milestone: "Thưởng mốc giới thiệu",
    cms_commission_vnđ: "Tạo thưởng tiền cms",
    cms_commission_chỉ: "Tạo thưởng vàng cms",
    cms_commission_hng: "Tạo thưởng hng cms",
    admin_send_VND_admin_remove: "Chuyển tiền cho TK trả thưởng",
    admin_send_gold_admin_remove: "Chuyển vàng cho TK trả thưởng",
    admin_send_HNG_admin_remove: "Chuyển HNG cho TK trả thưởng",
    reward_invest: "Thưởng HNG đầu tư vàng",
    recover_assets: "Thu hồi từ tài khoản trả thưởng",
    recover_assets_remove: "Hệ thống thu hồi",
    send_agency_ref_kyc: "Thưởng kyc thành công (đại sứ)",
    send_agency_ref_gold: "Thưởng mua vàng lần đầu (đại sứ)",
    admin_recovery_gold_lock: "Thu hồi thưởng mở tài khoản",
    send_reward_mission_2: "Thưởng nhiệm vụ Xác Nhận Tài Khoản (KYC)",
    send_reward_mission_3: "Thưởng nhiệm vụ Nạp Tiền Lần Đầu",
    send_reward_mission_4: "Thưởng nhiệm vụ Mua Vàng Lần Đầu",
    send_reward_mission_5: "Thưởng nhiệm vụ Tham Gia Cùng Hợp Tác Lần Đầu",
    send_reward_mission_6_milis_stone_1: "Thưởng nhiệm vụ Mốc tích lũy vàng 1",
    send_reward_mission_6_milis_stone_2: "Thưởng nhiệm vụ Mốc tích lũy vàng 2",
    send_reward_mission_6_milis_stone_3: "Thưởng nhiệm vụ Mốc tích lũy vàng 3",
    send_reward_mission_6_milis_stone_4: "Thưởng nhiệm vụ Mốc tích lũy vàng 4",
    send_reward_mission_6_milis_stone_5: "Thưởng nhiệm vụ Mốc tích lũy vàng 5",
    recover_lock_register: "Thu hồi vàng khoá",
    mkt_122023: "MKT T12/2023",
    send_reward_lixi : 'Chương trình lì xì',
    remove_withdraw_from_miniapp : 'Thưởng Mini App',
    refund_upgrade: 'Hoàn phí nâng cấp VIP 4'
  },
  MARKETING_EVENT: {
    admin_send_VND: "Admin gửi tiền",
    admin_send_gold: "Admin gửi vàng",
    admin_send_HNG: "Admin gửi HNG",
    reward_buy_gold: "Thưởng mua vàng",
    cms_commission_vnđ: "Tạo thưởng tiền cms",
    cms_commission_chỉ: "Tạo thưởng vàng cms",
    cms_commission_hng: "Tạo thưởng hng cms",
    recover_assets_remove: "Hệ thống thu hồi",
  },
  DEPOSIT_WITHDRAWAL: {
    admin_send_gold: "Admin gửi vàng",
    admin_send_VND: "Admin gửi tiền",
    admin_send_HNG: "Admin gửi HNG",
    deposit_money_admin_remove: "Nạp tiền - Chuyển tiền",
    withdraw_money_money_admin_add: "Rút tiền - Cộng tiền",
    withdraw_gold_money_admin_add: "Phí gia công",
    withdraw_gold_gold_admin_add: "Rút vàng -  Nhận vàng",
    cancel_withdraw_money: "Hủy rút tiền",
    withdraw_gold_user_cancel: "Hủy rút vàng",
    withdraw_gold_gold_admin_remove: "Rút vàng - Chuyển vàng",
    withdraw_gold_money_admin_remove: "Phí gia công chuyển đại sứ",
    withdraw_gold_agency_cancel: "Rút vàng - Đại sứ hủy",
    momo_deposit_money_admin_remove: "Rút tiền qua MoMo",
    cms_commission_vnđ: "Tạo thưởng tiền cms",
    cms_commission_chỉ: "Tạo thưởng vàng cms",
    cms_commission_hng: "Tạo thưởng hng cms",
    recover_assets_remove: "Hệ thống thu hồi",
    admin_receive_usdt_withdrawal : "Rút usdt",
    admin_send_usdt_deposit : "Nạp usdt",
    admin_refund_usdt_withdrawal : 'Hoàn rút usdt',
  },
  REWARD_POOL: {
    admin_send_gold: "Admin gửi vàng",
    admin_send_VND: "Admin gửi tiền",
    admin_send_HNG: "Admin gửi HNG",
    swap_money_gold: "Mua vàng",
    swap_gold_money_root: "Bán vàng",
    by_order_cancel: "Hủy đơn hàng",
    swap_HNG_VNĐ: "Bán HNG",
    swap_VNĐ_HNG: "Mua HNG",
    swap_USDT_VNĐ: "Bán USDT",
    swap_VNĐ_USDT: "Mua USDT",
    swap_USDT_XAU: "Mua XAUT bằng USDT",
    swap_TON_XAU: "Mua XAUT bằng TON",
    swap_TON_HNG: "Mua HNG bằng TON",
    swap_XAU_TON : "Bán XAUT nhận TON",
    swap_XAU_USDT: "Bán XAUT nhận USDT",
    swap_HNG_TON : "Bán HNG nhận TON",
    cms_commission_vnđ: "Tạo thưởng tiền cms",
    cms_commission_chỉ: "Tạo thưởng vàng cms",
    cms_commission_hng: "Tạo thưởng hng cms",
    recover_assets_remove: "Hệ thống thu hồi",
  },
  CASH_FLOW: {
    admin_send_gold: "Admin gửi vàng",
    admin_send_VND: "Admin gửi tiền",
    admin_send_HNG: "Admin gửi HNG",
    admin_send_USD: "Admin gửi USDT",
    admin_send_XAU: "Admin gửi XAUT",
    cms_commission_vnđ: "Tạo thưởng tiền cms",
    cms_commission_chỉ: "Tạo thưởng vàng cms",
    cms_commission_hng: "Tạo thưởng hng cms",
    recover_assets: "Thu hồi tài sản",
    recover_assets_remove: "Hệ thống thu hồi",
    admin_send_VND_admin_remove: "Chuyển tiền cho tài khoản nguồn",
    admin_send_gold_admin_remove: "Chuyển vàng cho tài khoản nguồn",
    admin_send_HNG_admin_remove: "Chuyển HNG cho tài khoản nguồn",
    admin_send_USD_admin_remove: "Chuyển USDT cho tài khoản nguồn",
    admin_send_XAU_admin_remove: "Chuyển XAUT cho tài khoản nguồn",
  },
  INVEST: {
    admin_send_gold: "Admin gửi vàng",
    admin_send_VND: "Admin gửi tiền",
    admin_send_HNG: "Admin gửi HNG",
    invest_root_remove: "Rút đầu tư",
    withdraw_invest_profit_root: "Trả vốn đầu tư",
    invest_root_add: "Đầu tư",
    cms_commission_vnđ: "Tạo thưởng tiền cms",
    cms_commission_chỉ: "Tạo thưởng vàng cms",
    cms_commission_hng: "Tạo thưởng hng cms",
    recover_assets_remove: "Hệ thống thu hồi",
    swap_gold_money_root: "Bán vàng",
    remove_recover_early_withdrawl_fee: "Phí rút trước hạn",
  },
  UPGRADE: {
    upgrade: "Nâng cấp VIP",
    admin_refund_upgrade: "Admin hoàn phí nâng cấp vip",
    admin_send_gold: "Admin gửi vàng",
    admin_send_VND: "Admin gửi tiền",
    admin_send_HNG: "Admin gửi HNG",
    recover_assets_remove: "Hệ thống thu hồi",
    admin_save_upgrade_agency: "Nâng cấp đại sứ",
    refund_upgrade_agency: "Hoàn phí nâng cấp đại sứ",
    recover_early_withdrawl_fee: "Phí rút trước hạn",
    priority_upgrade: 'Nâng cấp Priority',
    user_cancel_refund_priority_upgrade: 'Hủy nâng cấp Priority',
    admin_refund_priority_upgrade: 'Admin hoàn phí nâng cấp Priority',
    priority_extend: 'Gia hạn Priority',
  },
  SELL_PRODUCT: {
    by_order: "Mua hàng",
    by_order_cancel: "Huỷ đơn hàng",
    admin_send_gold: "Admin gửi vàng",
    admin_send_VND: "Admin gửi tiền",
    admin_send_HNG: "Admin gửi HNG",
    recover_assets_remove: "Hệ thống thu hồi",
    admin_save_upgrade_agency: "Phí nâng cấp đại sứ",
    refund_upgrade_agency: "Hoàn phí nâng cấp đại sứ",
  },
  EVOUCHER: {
    create_voucher: "Tạo E-Voucher",
    voucher_cashback: "E-Voucher hết hạn",
    use_voucher_remove: "Sử dụng E-Voucher",
    admin_send_gold: "Admin gửi vàng",
    admin_send_VND: "Admin gửi tiền",
    admin_send_HNG: "Admin gửi HNG",
    recover_assets_remove: "Hệ thống thu hồi",
  },
};

export const TRANSACTION_ROOT = {
  admin_send_gold_admin_remove: "Chuyển vàng",
  admin_send_HNG_admin_remove: "Chuyển HNG",
  admin_send_VND_admin_remove: "Chuyển tiền",
  admin: "Nạp tiền vào tài khoản Tổng",
  cms_commission_vnđ: "Tạo thưởng tiền cms",
  cms_commission_chỉ: "Tạo thưởng vàng cms",
  cms_commission_hng: "Tạo thưởng hng cms",
  recover_assets: "Thu hồi tài sản",
  Reward_invest_refferal: "Hoa hồng giới thiệu đầu tư hàng ngày",
};

export const TRANSACTION_ALL = {
  admin: "Nạp tiền vào tài khoản Tổng",
  admin_lock_gold: "Bị khoá Vàng",
  admin_lock_vnd: "Bị khoá Tiền",
  admin_send_gold: "Admin gửi vàng",
  admin_send_VND: "Admin gửi tiền",
  admin_send_HNG: "Admin gửi HNG",
  admin_send_gold_admin_remove: "Chuyển vàng",
  admin_send_HNG_admin_remove: "Chuyển HNG",
  admin_send_VND_admin_remove: "Chuyển tiền",
  admin_unlock_gold: "Mở khoá Vàng",
  admin_unlock_vnd: "Mở khoá Tiền",
  by_order: "Mua hàng",
  by_order_cancel: "Huỷ đơn hàng",
  cancel_withdraw_money: "Hủy rút tiền",
  claim: "Rút hoa hồng",
  cms_commission_vnđ: "Thưởng Tiền từ CMS",
  cms_commission_chỉ: "Thưởng Vàng từ CMS",
  cms_commission_hng: "Thưởng HNG từ CMS",
  commission_swap_money_gold: "Hoa hồng cho đại sứ khi user mua vàng",
  create_voucher: "Nhận tài sản tạo E-Voucher",
  create_voucher_gold: "Tạo E-Voucher Vàng",
  create_voucher_hng: "Tạo E-Voucher HNG",
  create_voucher_money: "Tạo E-Voucher Tiền",
  "Daily reward": "Thưởng hàng ngày",
  deposit: "Nạp tiền",
  deposit_money_admin_remove: "Nạp tiền - Chuyển tiền",
  invest: "Đầu tư",
  invest_root_add: "Nhận tài sản đầu tư",
  invest_root_remove: "Chuyển rút đầu tư",
  kyc_success: "Thưởng KYC",
  kyc_success_remove_coin: "Trả thưởng KYC",
  lixi_remove_coin: "Tặng Lì xì",
  mkt_2_9_23: "Thưởng đầu tư",
  recover_assets: "Thu hồi tài sản",
  referral_gold_invitee: "Thường người dùng mới",
  referral_gold_inviter: "Thưởng giới thiệu",
  referral_gold_inviter_remove_coin: "Trả thưởng giới thiệu",
  ref_invest: "Hoa hồng đầu tư",
  ref_register: "Thưởng giới thiệu đăng ký tài khoản",
  reward_buy_gold: "Thưởng mua Vàng",
  reward_buy_HNG: "Thưởng mua HNG",
  reward_daily: "Thưởng hàng ngày",
  reward_invest: "Thưởng HNG đầu tư vàng",
  Reward_invest_refferal: "Hoa hồng giới thiệu đầu tư hàng ngày",
  reward_milestone: "Thưởng mốc giới thiệu",
  reward_user_buy_HNG_admin_remove: "Thưởng mua HNG",
  send_agency_ref_gold: "Hoa hồng mua vàng lần đầu",
  send_agency_ref_kyc: "Thưởng KYC",
  send_gold_agency_user: "Gửi vàng từ đại sứ",
  send_gold_master_user: "Nhận vàng từ Admin",
  send_gold_master_user_remove: "Chuyển vàng cho người dùng",
  send_reward_new_account: "Thưởng tài khoản mới(CHỈ)",
  swap_gold_money: "Người dùng bán vàng",
  swap_gold_money_root: "Hệ thống nhận bán vàng",
  swap_HNG_VNĐ: "Bán HNG",
  swap_money_gold: "Mua vàng",
  swap_VNĐ_HNG: "Mua HNG",
  upgrade: "Nâng cấp VIP",
  use_voucher_gold: "Nạp E-Voucher Vàng",
  use_voucher_hng: "Nạp E-Voucher HNG",
  use_voucher_money: "Nạp E-Voucher Tiền",
  use_voucher_remove: "Chuyển tài sản E-Voucher",
  voucher_cashback: "E-Voucher hết hạn",
  voucher_expired: "Nhận lại E-Voucher hết hạn",
  withdraw_gold: "Nhận vàng",
  withdraw_gold_user_cancel: "Hủy rút vàng",
  withdraw_gold_gold_admin_remove: "Rút vàng - Chuyển vàng",
  withdraw_gold_money_admin_remove: "Phí gia công chuyển đại sứ",
  withdraw_gold_agency_cancel: "Rút vàng - Đại sứ hủy",
  momo_deposit_money_admin_remove: "Rút tiền qua MoMo",
  withdraw_gold_gold_admin_add: "Rút vàng -  Nhận vàng",
  withdraw_gold_money_admin_add: "Phí gia công",
  withdraw_invest: "Rút đầu tư",
  withdraw_invest_profit: "Lãi đầu tư",
  withdraw_invest_profit_root: "Vốn đầu tư",
  withdraw_money: "Rút tiền",
  withdraw_money_money_admin_add: "Rút tiền - Cộng tiền",
  admin_recovery_gold_lock: "Thu hồi thưởng mở tài khoản",
  send_reward_mission_2: "Thưởng nhiệm vụ Xác Nhận Tài Khoản (KYC)",
  send_reward_mission_3: "Thưởng nhiệm vụ Nạp Tiền Lần Đầu",
  send_reward_mission_4: "Thưởng nhiệm vụ Mua Vàng Lần Đầu",
  send_reward_mission_5: "Thưởng nhiệm vụ Tham Gia Cùng Hợp Tác Lần Đầu",
  send_reward_mission_6_milis_stone_1: "Thưởng nhiệm vụ Mốc tích lũy vàng 1",
  send_reward_mission_6_milis_stone_2: "Thưởng nhiệm vụ Mốc tích lũy vàng 2",
  send_reward_mission_6_milis_stone_3: "Thưởng nhiệm vụ Mốc tích lũy vàng 3",
  send_reward_mission_6_milis_stone_4: "Thưởng nhiệm vụ Mốc tích lũy vàng 4",
  send_reward_mission_6_milis_stone_5: "Thưởng nhiệm vụ Mốc tích lũy vàng 5",
};

export const ListItemPerPage = [10, 15, 20, 50];
/////////////////////// End Master ///////////////////////////////////
